<template>
	<div class="grid-container">
		<h1>{{commercant.title}}</h1>
		<div class="grid-x grid-padding-x">
			<div class="cell large text-center" v-show="loader">CHARGEMENT...</div>
			<div class="cell small-12 medium-4">
				<img :src="commercant.thumbnail" alt="">
			</div>
			<div class="cell small-12 medium-8">
				<p>
				{{commercant.text}}
				</p>
				<a :href="commercant.link" class="button large">Commander</a>
			</div>
		</div>
		<hr>
		<div class="grid-x grid-padding-x commercant-emplacements">
			<div class="cell large">
				<h2>Commander chez {{commercant.title}} dans les 3 prochains jours</h2>
			</div>
			<div class="cell large">
				<LocalMap v-bind:autoload="false"/>
			</div>
		</div>
	</div>
</template>

<script>
    import LocalMap from "../components/LocalMap.vue";
    export default {
        name: "Commercant",
        props: {},
        components: {
            LocalMap
        },
        mounted() {
            this.$ga.page('/commercant/'+this.$route.params.id);
            this.$store.dispatch("fetchCommercant", this.$route.params.id);
        },
        computed: {
            commercant: function () {
                return this.$store.state.commercant;
            },
            loader: function () {
                return this.$store.state.loader;
            },
        }
    };
</script>